module.exports = __webpack_public_path__ + "b269aba7d4cd009962d9cde279fdac64.svg";